import type {
  ClientDiagnosticEventCode,
  ClientDiagnosticOutcome,
  ClientRouteCategory,
} from './generated';

import { reportClientDiagnostic } from './clientDiagnostics';

/**
 * Report a browser-only lifecycle milestone using the closed diagnostic schema.
 *
 * Callers cannot attach filenames, field values, routes, or other free-form data.
 */
export function reportLifecycleDiagnostic(
  eventCode: ClientDiagnosticEventCode,
  routeCategory: ClientRouteCategory,
  outcome: ClientDiagnosticOutcome,
): void {
  reportClientDiagnostic({
    event_code: eventCode,
    outcome,
    route_category: routeCategory,
    timing_bucket: 'not_recorded',
  });
}
